"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderDropdownLink = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _link = require("../../link");

var _constants = require("../../button/constants");

var _PageHeaderLink = require("./PageHeaderLink");

var _core = require("@emotion/core");

var SpanRow = _layout.Row.withComponent('span', {
  target: "e1fwququ0"
});

var getWrapperComponent = function getWrapperComponent(tag) {
  return (0, _context.styledWithTheme)(_link.Link.withComponent(tag, {
    target: "e1fwququ1"
  }))(function (_ref) {
    var selectors = _ref.theme.selectors;
    return {
      border: "".concat(_constants.BORDER_WIDTH, "px solid transparent"),
      backgroundColor: selectors.color('neutral0'),
      display: 'block',
      fontWeight: selectors.fontWeight('regular'),
      height: '100%',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: selectors.color('primary05'),
        borderColor: selectors.color('primary70'),
        textDecoration: 'none'
      },
      '&:active': {
        borderColor: selectors.color('primary80')
      },
      '&:focus': {
        outlineColor: selectors.color('primary80'),
        outlineOffset: '-2px'
      }
    };
  });
};

var PageHeaderDropdownLinkWithoutDocs = function PageHeaderDropdownLinkWithoutDocs(_ref2) {
  var icon = _ref2.icon,
      dataTestId = _ref2.dataTestId,
      children = _ref2.children,
      _ref2$wrapper = _ref2.wrapper,
      wrapper = _ref2$wrapper === void 0 ? _link.Link : _ref2$wrapper,
      linkProps = (0, _objectWithoutProperties2.default)(_ref2, ["icon", "dataTestId", "children", "wrapper"]);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeaderDropdownLink',
    dataTestId: dataTestId
  });
  var Wrapper = getWrapperComponent(wrapper);
  return (0, _core.jsx)(Wrapper, (0, _extends2.default)({}, linkProps, dataTestProps), (0, _core.jsx)(SpanRow, {
    alignItems: "center",
    gridGap: icon ? 'S100' : undefined,
    height: "100%",
    padding: [16, 24]
  }, !!icon && icon, !!children && children));
};

var PageHeaderDropdownLinkStyled = PageHeaderDropdownLinkWithoutDocs;

PageHeaderDropdownLinkStyled.withComponent = function (tag) {
  var Wrapper = _link.Link.withComponent(tag, {
    target: "e1fwququ2"
  });

  Wrapper.defaultProps = (0, _objectSpread2.default)({}, _link.Link.defaultProps);
  return function (props) {
    return (0, _core.jsx)(PageHeaderDropdownLink, (0, _extends2.default)({}, props, {
      wrapper: Wrapper
    }));
  };
};

var PageHeaderDropdownLink = (0, _stencilReactDesc.describe)(PageHeaderDropdownLinkStyled).description('Link dropdown item for PageHeader.');
exports.PageHeaderDropdownLink = PageHeaderDropdownLink;
PageHeaderDropdownLink.displayName = 'PageHeaderDropdownLink';
PageHeaderDropdownLink.propTypes = (0, _objectSpread2.default)({}, _link.Link.describedPropTypes, (0, _utils.pick)(_PageHeaderLink.PageHeaderLink.describedPropTypes, ['dataTestId', 'children', 'icon']));